import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const META = {
  "planes-fta": { title: "Planes × FTA", kicker: "FTA × Paper Planes" },
  "fta-fall":   { title: "FTA Fall Collection", kicker: "Freedom Thinkers Academy" },
};

export default function CollectionPage() {
  const { collection } = useParams();
  const nav = useNavigate();
  const API = process.env.REACT_APP_BACKEND_URL;
  const [items, setItems] = useState([]);
  const meta = META[collection];

  useEffect(() => {
    if (!meta) { nav("/"); return; }
    document.title = `${meta.title} · Philadelphia Freeway`;
    fetch(`${API}/api/products`).then(r => r.json()).then((all) => setItems(all.filter(p => p.collection === collection)));
  }, [collection, API, meta, nav]);

  if (!meta) return null;
  return (
    <div className="App relative bg-white min-h-screen text-black flex flex-col" style={{ background: "white" }}>
      <Navbar />
      <main className="flex-1">
        <div className="max-w-[1400px] mx-auto px-4 md:px-10 pt-28 md:pt-36 pb-16 md:pb-24">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B48A00] mb-3">{meta.kicker}</div>
          <h1 className="font-wide uppercase text-4xl sm:text-5xl md:text-6xl">{meta.title}</h1>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-8" data-testid="collection-grid">
            {items.map((p) => (
              <Link key={p.slug} to={`/product/${p.slug}`} data-testid={`collection-item-${p.slug}`} className="group">
                <div className="relative aspect-square bg-neutral-100 overflow-hidden">
                  <img src={p.images[0]} alt={p.name} loading="lazy" className="w-full h-full object-contain p-4 transition-transform duration-500 group-hover:scale-105"/>
                  {p.is_new && <span className="absolute top-3 left-3 bg-black text-white text-[10px] font-mono tracking-[0.25em] px-2 py-1">NEW</span>}
                </div>
                <div className="mt-3">
                  <div className="font-display uppercase text-sm leading-tight line-clamp-2">{p.name}</div>
                  <div className="mt-1 font-mono text-xs">${p.price.toFixed(2)}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
